var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-blacker-badge',{attrs:{"color":_vm.badgeColor,"small":""}},[_c('span',{staticClass:"colored-state-badge"},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.state)+" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }